/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthSubmissionStatusInfo
 */
export interface PalReauthSubmissionStatusInfo {
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionStatusInfo
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionStatusInfo
     */
    level?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionStatusInfo
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the PalReauthSubmissionStatusInfo interface.
 */
export function instanceOfPalReauthSubmissionStatusInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalReauthSubmissionStatusInfoFromJSON(json: any): PalReauthSubmissionStatusInfo {
    return PalReauthSubmissionStatusInfoFromJSONTyped(json, false);
}

export function PalReauthSubmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionStatusInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function PalReauthSubmissionStatusInfoToJSON(value?: PalReauthSubmissionStatusInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'level': value.level,
        'comment': value.comment,
    };
}

